// START REBUY 'BOOK NOW' LINK FIX

// Event listener for potential 'book now' links redirecting user to the boulevard app
// 5.25.23 Rebuy Smart Cart widget targets these urls per the href containing '/cart'
// and prevents default behavior to instead open the cart, requiring this work-around

// May have been fixed by Rebuy or may simply be happing sometimes and not others, in the meantime
// maintaining as a fallback to Rebuy-related bugginess
$('#MainContent').on('click', 'a', function(event) {
    let $link = $(event.target).closest('a');
    let link_href = $link.attr('href');

    if (link_href === 'https://dashboard.boulevard.io/booking/businesses/95ca4110-b557-4e1d-aa51-4106155b84fa/widget#/cart/menu') {
        console.log('direct boulevard link detected!');
        event.preventDefault();
        window.open('https://dashboard.boulevard.io/booking/businesses/95ca4110-b557-4e1d-aa51-4106155b84fa/widget#/cart/menu','_blank');
    } else if (link_href === 'https://dashboard.boulevard.io/booking/businesses/95ca4110-b557-4e1d-aa51-4106155b84fa/widget?path=/cart/menu/JOIN%20CLUB%20CHILL&locationId=d5147742-810e-4cd3-bac7-caab222f91a4&visitType=SELF_VISIT') {
        event.preventDefault();
        window.open('https://dashboard.boulevard.io/booking/businesses/95ca4110-b557-4e1d-aa51-4106155b84fa/widget?path=/cart/menu/JOIN%20CLUB%20CHILL&locationId=d5147742-810e-4cd3-bac7-caab222f91a4&visitType=SELF_VISIT','_blank');
    } else if (link_href.indexOf('/cart/menu/FACE') > -1) {
        console.log('boulevard widget click detected!');
        event.preventDefault();
        blvd.openBookingWidget({ urlParams: { locationId: 'd5147742-810e-4cd3-bac7-caab222f91a4', path: '/cart/menu/FACE', visitType: 'SELF_VISIT' }});
    } else if (link_href.indexOf('/cart/menu/BODY') > -1) {
        console.log('boulevard widget click detected!');
        event.preventDefault();
        blvd.openBookingWidget({ urlParams: { locationId: 'd5147742-810e-4cd3-bac7-caab222f91a4', path: '/cart/menu/BODY', visitType: 'SELF_VISIT' }});
    } else if (link_href.indexOf('/cart/menu/MANICURES') > -1) {
        console.log('boulevard widget click detected!');

        event.preventDefault();
        blvd.openBookingWidget({ urlParams: { locationId: 'd5147742-810e-4cd3-bac7-caab222f91a4', path: '/cart/menu/MANICURES', visitType: 'SELF_VISIT' }});
    } else if (link_href.indexOf('/cart/menu/NAIL ART') > -1) {
        console.log('boulevard widget click detected!');
        event.preventDefault();
        blvd.openBookingWidget({ urlParams: { locationId: 'd5147742-810e-4cd3-bac7-caab222f91a4', path: '/cart/menu/NAIL ART', visitType: 'SELF_VISIT' }});
    } else if (link_href.indexOf('/cart/menu/PEDICURES') > -1) {
        console.log('boulevard widget click detected!');
        event.preventDefault();
        blvd.openBookingWidget({ urlParams: { locationId: 'd5147742-810e-4cd3-bac7-caab222f91a4', path: '/cart/menu/PEDICURES', visitType: 'SELF_VISIT' }});
    } else if (link_href.indexOf('/cart/menu/CHILL HEAT') > -1) {
        console.log('boulevard widget click detected!');
        event.preventDefault();
        blvd.openBookingWidget({ urlParams: { locationId: 'd5147742-810e-4cd3-bac7-caab222f91a4', path: '/cart/menu/CHILL HEAT', visitType: 'SELF_VISIT' }});
    }
});
  
  // END REBUY 'BOOK NOW' LINK FIX